<div
    class="flex flex-row search p-1 items-center"
    [class.narrow-searchbar]="isNarrowSearchBar()">
    <fa-icon
        class="icon-searchbar mr-2 text-gray-300 text-base"
        matIconPrefix
        size="lg"
        [icon]="['fas', 'search']" />
    <input
        class="w-4/5 border-none text-base bg-transparent placeholder:text-gray-400 outline-none"
        matInput
        type="text"
        [placeholder]="'search' | transloco"
        [(ngModel)]="searchValue"
        (input)="onSearchValue()" />
    @if (searchValue.length) {
        <fa-icon
            class="mx-2 text-gray-300 text-sm cursor-pointer"
            matIconPrefix
            size="lg"
            [icon]="['far', 'xmark']"
            (click)="clearSearch()" />
    }
</div>
